import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationObject } from "src/constant";
import { getAxios } from "src/helpers/index";

//get All dispatch order section
export const getAllDispatchOrderData = createAsyncThunk(
  "dispatchOrder/getAllDispatchOrderData",
  async (model, thunkAPi) => {
    try {
      let url = "/DeliveryOrder/GetDeliveryOrders";
      if (model?.from) {
        url = `${url}?from=${model?.from}`;
      }
      if (model?.to) {
        url = `${url}&to=${model?.to}`;
      }
      if (model?.DepotIds) {
        url = `${url}&depotIds=${model?.DepotIds}`;
      }
      if (model?.ClientIds) {
        url = `${url}&clientIds=${model?.ClientIds}`;
      }
      if (model?.ProjectIds) {
        url = `${url}&projectIds=${model?.ProjectIds}`;
      }
      {
        url = `${url}&isDateRange=${model?.isDateRange}&currentPage=${model.currentPage || 1
          }&pageSize=${model?.pageSize || 1000}&typeId=${model?.typeId || ""}`;
      }
      let res = await getAxios().get(`${url}`);
      return res?.data || [];
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const getAllDispatchOrderDataLoading = createAsyncThunk(
  "dispatchOrder/getAllDispatchOrderDataLoading",

  async (model, thunkAPi) => {
    try {
      let url = "/DeliveryOrder/GetDeliveryOrders";
      if (model?.from) {
        url = `${url}?from=${model?.from}`;
      }
      if (model?.to) {
        url = `${url}&to=${model?.to}`;
      }
      if (model?.DepotIds) {
        url = `${url}&depotIds=${model?.DepotIds}`;
      }
      if (model?.ClientIds) {
        url = `${url}&clientIds=${model?.ClientIds}`;
      }
      if (model?.ProjectIds) {
        url = `${url}&projectIds=${model?.ProjectIds}`;
      }
      {
        url = `${url}&isDateRange=${model?.isDateRange}&currentPage=${model.currentPage || 1
          }&pageSize=${model?.pageSize || 1000}&typeId=${model?.typeId || ""}`;
      }
      let res = await getAxios().get(`${url}`);
      return res?.data || [];
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const getAllItemsByProjectId = createAsyncThunk(
  "dispatchOrder/getAllItemsByProjectId",
  async (model, thunkAPi) => {
    try {
      if (model) {
        let res = await getAxios().get(`/DeliveryOrder/items/${model}`);
        return res.data;
      } else {
        return [];
      }
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const addNewDispatchOrder = createAsyncThunk(
  "dispatchOrder/addNewDispatchOrder",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().post("/DeliveryOrder", model);
      const notificationData = notificationObject("Delivery Order", "Create");
      const approveNofnData = notificationObject("Delivery Order", "Approve")
      const commonNofnObj = {
        ResourceId: parseInt(res?.data),
        OrderNo: model?.orderNo,
        TimeStamp: new Date().toISOString(),
        ClientId: model?.clientId,
        ClientName: model?.ClientName,
        ProjectId: model?.projectId,
        DeliveryOrderType: model?.typeName,
        ProjectName: model?.projectName,
        DeliveryOrderDueDate: model?.dueDate,
      }
      const notificationObj = {
        ...commonNofnObj,
        ...(model?.role === "ProjectManager" ? {} : { DepotId: model?.depotId }),
        ...notificationData,
      };
      await getAxios().post("/ActivityLog", {
        activityLogs: [JSON.stringify(notificationObj)],
      });
      setTimeout(async () => {
        if (model?.statusId == 8) {
          const nofnObj = {
            ...commonNofnObj,
            ...approveNofnData,
            ResourceId: parseInt(res?.data),
            DeliveryOrderNo: model?.orderNo,
          }
          await getAxios().post("/ActivityLog", {
            activityLogs: [JSON.stringify(nofnObj)],
          });
        }
      }, 1000);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const editDispatchOrder = createAsyncThunk(
  "dispatchOrder/editDispatchOrder",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().put(`/DeliveryOrder/${model.id}`, model);
      let notficationObj = {
        ResourceId: parseInt(model?.id),
        DeliveryOrderNo: model?.orderNo,
        ProjectId: model?.projectId,
        DepotId: model?.depotId,
        TimeStamp: new Date().toISOString(),
        DeliveryOrderType: model?.typeName,
        ...notificationObject(
          "Delivery Order",
          model?.statusId == 12
            ? "Cancel"
            : (model?.statusId == 8 && model?.acceptOrder)
              ? "Approve"
              : "Update"
        ),
      };
      let notficationObj1 = {
        ResourceId: parseInt(model?.id),
        DeliveryOrderNo: model?.orderNo,
        ProjectId: model?.projectId,
        TimeStamp: new Date().toISOString(),
        DeliveryOrderType: model?.typeName,
        ...notificationObject(
          "Delivery Order",
          model?.statusId == 12
            ? "Cancel"
            : model?.statusId == 8
              ? "Approve"
              : "Update"
        ),
      };
      await getAxios().post("/ActivityLog", {
        activityLogs: [
          JSON.stringify(
            model?.role == "ProjectManager" ? notficationObj1 : notficationObj
          ),
        ],
      });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const getDispatchOrderByIdAction = createAsyncThunk(
  "dispatchOrder/getDispatchOrderByIdAction",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`/deliveryorder/${model.id}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const saveNewLaodInData = createAsyncThunk(
  "dispatchOrder/saveNewLaodInData",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().post(
        `DeliveryOrder/${model.deliveryOrderId}/dispatches`,
        model
      );
      let notficationObj = {
        ResourceId: parseInt(model?.deliveryOrderId),
        OrderNo: model?.orderNo,
        DepotId: model?.depotId,
        TimeStamp: new Date().toISOString(),
        ClientName: model?.ClientName,
        ProjectId: model?.projectId,
        DeliveryOrderType: model?.typeName,
        DueDate: model?.dispatchDueDate,
        ...notificationObject(
          "Dispatch",
          model?.id
            ? "InTransit"
            : model?.isUpdateFlag
              ? "Update"
              : model?.dispatchStatus
                ? "Delivered"
                : "Create"
        ),
      };
      await getAxios().post("/ActivityLog", {
        activityLogs: [JSON.stringify(notficationObj)],
      });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const deleteDeliveryOrderRecord = createAsyncThunk(
  "goodsin/deleteDeliveryOrderRecord",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().delete(`/DeliveryOrder/${model.id}`);
      let notficationObj = {
        OrderNo: model?.orderNo,
        DeliveryOrderType: model?.typeName,
        DeliveryOrderNo: model?.orderNo,
        ProjectId: model?.ProjectId,
        ...notificationObject("DeliveryOrder", "Remove"),
      };
      await getAxios().post("/ActivityLog", {
        activityLogs: [JSON.stringify(notficationObj)],
      });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const DispatchDocumentUpload = createAsyncThunk(
  "DispatchDocumentUpload",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        "/DeliveryOrder/dispatchEvidences",
        model
      );
      return res?.data || [];
    } catch (error) {
      thunkApi.rejectWithValue("error");
    }
  }
);
